import React from "react";
import "@/App.css";

import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import KomoditasSection from "@/components/KomoditasSection";
import ProdukKamiSection from "./components/ProdukKamiSection";
import FasilitasKamiSection from "./components/FasilitasKamiSection";
import MengapaShaktiSection from "./components/MengapaShaktiSection";
import KolaborasiSection from "./components/KolaborasiSection";
import SertifikasiDanKeunggulanSection from "./components/SertifikasiDanKeunggulanSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <KomoditasSection />
        <FasilitasKamiSection />

        <ProdukKamiSection />
        <SertifikasiDanKeunggulanSection />
        <MengapaShaktiSection />
        <KolaborasiSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
